import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import mobileRouters from './routes';
import 'antd-mobile/es/global'; // ✅ Antd-Mobile 全局样式（如使用）
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <RouterProvider router={mobileRouters} />
    </ConfigProvider>
  </React.StrictMode>
);
